export default __webpack_public_path__ + "static/media/center.fdb1e405.png";